import { PanelLeftClose, PanelLeftOpen, Waypoints } from 'lucide-react';
import { useUiStore } from '../../../store/ui.store';
import { Tooltip } from '../../ui/Tooltip';

/** The Multi-PERT wordmark + gradient icon tile at the top of the sidebar, plus the
 *  collapse/expand toggle. Collapsed state drops the wordmark and centers just the icon. */
export function SidebarBrand() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const toggleCollapsed = useUiStore((s) => s.toggleSidebarCollapsed);

  const iconTile = (
    <div
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-white"
      style={{ background: 'linear-gradient(155deg, #1D5AA6, #154580)' }}
    >
      <Waypoints size={20} />
    </div>
  );

  const toggleButton = (
    <Tooltip label={collapsed ? 'ขยายแถบเมนู' : 'ย่อแถบเมนู'} side={collapsed ? 'right' : 'bottom'}>
      <button
        type="button"
        onClick={toggleCollapsed}
        aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        className="hidden shrink-0 items-center justify-center rounded-lg p-1.5 text-text-tertiary hover:bg-surface-hover hover:text-text-primary md:flex"
      >
        {collapsed ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
      </button>
    </Tooltip>
  );

  if (collapsed) {
    return (
      <div className="flex flex-col items-center gap-2 px-1 pb-4">
        {iconTile}
        {toggleButton}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 px-1 pb-4">
      {iconTile}
      <div className="min-w-0 flex-1 overflow-hidden">
        <p className="truncate font-display text-[15px] font-bold text-text-primary">Multi-PERT</p>
        <p className="truncate text-[10px] font-semibold uppercase tracking-wide text-text-secondary">PERT Scheduling · Tracking</p>
      </div>
      {toggleButton}
    </div>
  );
}
